// extracted by mini-css-extract-plugin
export default {"container":"SiteInfo_container__U2W3f","siteTitle":"SiteInfo_siteTitle__BhuDF","siteAddress":"SiteInfo_siteAddress__gLwu0"};